import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import CheckBox from '@node-space/storybook-components/dist/CheckBox'
import Input from '@node-space/storybook-components/dist/Input'
import { Box } from '@node-space/ui-components'
import { useConfirmIndustryPreference } from 'hooks/useConfirmIndustryPreference'
import { FormSubmitButton } from 'pages/Verification/_components/FormSubmitButton'
import { FormSubmitError } from 'pages/Verification/_components/FormSubmitError'
import { VerificationIntroduction } from 'pages/Verification/_components/VerificationIntroduction'

export interface VerticalConfirmationProps {
  industryName: string
}

export const VerticalConfirmation = ({ industryName }: VerticalConfirmationProps) => {
  const { t } = useTranslation()
  const [isChecked, setIsChecked] = useState(false)
  const { isUpdatingIndustryPreference, updateIndustryRequestError, onUpdateIndustryPreference } =
    useConfirmIndustryPreference()

  const handleConfirmIndustryVertical = () => {
    onUpdateIndustryPreference(true)
  }

  return (
    <Box flex isFlexCol gap={16} paddingT={16}>
      {updateIndustryRequestError?.show && (
        <FormSubmitError
          errorCode={updateIndustryRequestError?.errorCode}
          sentryTraceId={updateIndustryRequestError?.sentryTraceId}
        />
      )}
      <VerificationIntroduction
        textList={[
          t('uploadDocuments.confirmVertical.introduction'),
          t('uploadDocuments.confirmVertical.pleaseConfirm'),
        ]}
      />
      {industryName && <Input label={t('verification.industry')} value={industryName} disabled />}
      <Box paddingY={8}>
        <CheckBox
          label={t('uploadDocuments.confirmVertical.checkboxLabel')}
          value={isChecked}
          onChange={() => setIsChecked(current => !current)}
        />
      </Box>
      <FormSubmitButton
        disabled={!isChecked}
        loading={isUpdatingIndustryPreference}
        onClick={handleConfirmIndustryVertical}
      />
    </Box>
  )
}
